import { render, staticRenderFns } from "./ManagedListAttributesServerTable.vue?vue&type=template&id=514a8fb9"
import script from "./ManagedListAttributesServerTable.vue?vue&type=script&lang=js"
export * from "./ManagedListAttributesServerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports